import { FC, ReactNode } from 'react'
import {
  useTheme,
  Theme,
  FormHelperText,
  SxProps,
  Typography,
} from '@mui/material'

export type LoadedFormLabelProps = {
  label?: ReactNode
  labelPosition?: 'left' | 'above'
  error?: string
  sx?: SxProps<Theme>
}

const LoadedFormLabel: FC<LoadedFormLabelProps> = ({
  label,
  labelPosition = 'above',
  error,
  sx,
}) => {
  const theme = useTheme<Theme>()

  return (
    <>
      <Typography
        variant="subtitle2"
        sx={{
          fontSize:
            labelPosition === 'above' ? '1.2rem' : theme.typography.fontSize,
          fontWeight: 400,
          letterSpacing: '0.048rem',
          color: theme.palette.text.primary,
          minWidth: labelPosition === 'left' ? '6rem' : 'unset',
          ...(labelPosition === 'left' && { paddingRight: '2rem' }),
          ...sx,
        }}
      >
        {label}
      </Typography>

      {error && (
        <FormHelperText error={!!error} sx={{ marginTop: '0rem !important' }}>
          {error}
        </FormHelperText>
      )}
    </>
  )
}

export default LoadedFormLabel
